import React, { useState, useEffect, useRef } from 'react'
import { startCase } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'

import { Accordion } from '@/components/accordions/Accordion'
import { Card } from '@/components/cards/Card'
import { Pill } from '@/components/pills/Pill'
import { fetchRecentQuestions } from '@/reducers/recentQuestions/recentQustions.actions'
import { setData } from '@/reducers/recentQuestions/recentQuestions.redux'

import './SuggestedQuestions.scss'

export const SuggestedQuestions = ({
  initialCategory = '',
  questions = [],
  onQuestionClick,
  feature,
  narrow = false,
  autoCollapse = false,
}) => {
  const [selectedCategory, setSelectedCategory] = useState(initialCategory)
  const [collapsed, setCollapsed] = useState(false)
  const dispatch = useDispatch()
  const { data } = useSelector((state) => state.recentQuestions)
  const recentQuestionsFirstLoad = useRef(true)

  const questionsWithRecent =
    data.questions.length > 0
      ? {
          Recent: data.questions.map(({ question }) => question),
          ...questions,
        }
      : questions

  const handleCategoryClick = (category) => {
    setSelectedCategory(category)
  }

  const handleQuestionClick = (question) => {
    onQuestionClick(question)
  }

  const handleCollapse = () => {
    setCollapsed(!collapsed)
  }

  useEffect(() => {
    if (feature) {
      dispatch(fetchRecentQuestions(feature))
    }

    return () => {
      dispatch(setData({ questions: [] }))
    }
  }, [])

  useEffect(() => {
    if (recentQuestionsFirstLoad.current) {
      if (data.questions.length > 0) {
        setSelectedCategory('Recent')
        recentQuestionsFirstLoad.current = false
      }
    }
  }, [data.questions])

  useEffect(() => {
    setCollapsed(autoCollapse)
  }, [autoCollapse])

  return (
    <div className="suggested-question-container" data-testid="suggested-question-container">
      <Accordion
        id="suggested-questions"
        large
        title={<span className="muted-text">Suggested Questions</span>}
        expanded={!collapsed}
        handleToggle={handleCollapse}
      >
        <div className="category-container" data-testid="category-container">
          {Object.keys(questionsWithRecent).map((category) => (
            <Pill
              key={category}
              clickable
              onClick={() => handleCategoryClick(category)}
              contrast={selectedCategory === category}
              className="category"
              data-testid={`${category}-pill`}
            >
              {startCase(category)}
            </Pill>
          ))}
        </div>
        <div
          className={classNames('question-container', { narrow })}
          data-testid="question-container"
        >
          {questionsWithRecent[selectedCategory].map((question, index) => (
            <Card
              key={question}
              className="question"
              onClick={() => handleQuestionClick(question)}
              data-testid={`question-${index}`}
            >
              {question}
            </Card>
          ))}
        </div>
      </Accordion>
    </div>
  )
}
